import React from 'react';
import PropTypes from 'prop-types';
import styles from './NewDocumentMenu.scss';
import { Image } from 'semantic-ui-react';

const NewDocumentMenuItem = ({ color, description, icon, onClick, style, title }) => (
  <div className={styles.item} onClick={onClick} style={style}>
    <div className={styles.icon}>
      <Image src={icon} />
    </div>
    <div>
      <div className={[styles.title, styles[color]].join(' ')}>
        {title}
      </div>
      <div className={styles.description}>
        {description}
      </div>
    </div>
  </div>
);

NewDocumentMenuItem.propTypes = {
  color: PropTypes.string,
  description: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string.isRequired
};

export default NewDocumentMenuItem;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/NewDocumentMenuItem.js